import { NewChannelEntity, DefaultEntity } from '@/types';
import { BaseService } from './base.service';
import APIService from './axios.service';

class ChannelServiceClass extends BaseService<
  'channel',
  DefaultEntity,
  DefaultEntity
> {
  constructor() {
    super('projects');
  }

  findChannel = (): Promise<NewChannelEntity[]> => {
    return APIService.get(this.path + '/channel');
  };
}

export const channelService = new ChannelServiceClass();
